export const QUERY_PARAMS = {
  covidCoreCheckout: 'covid-core-checkout',
  regionId: 'region_id',
  MARKETING: {
    campaignId: 'iterable_campaign',
  },
};

// Region IDs configured in Google Merchant Center, passed
// in via the region_id param appended by the shopping feed
export const REGION_IDS = {
  NEW_YORK: 123456,
};
